import axios, { AxiosInstance } from "axios";
import { IKeepaSearchResult, SEARCH_ROWS, TYPESENSE_API_KEY, TYPESENSE_URL } from "../data/constants";

export default class TypesenseSearch {
  private init = (): AxiosInstance => {
    const headers = {
      Accept: "application/json",
    };
    return axios.create({
      baseURL: TYPESENSE_URL,
      headers: headers,
    });
  };

  searchArticles = async (searchString: string, filterCategory: number, rows = SEARCH_ROWS) => {
    const { data, status } = await this.init().get("/collections/keepa/documents/search", {
      headers: { "X-TYPESENSE-API-KEY": TYPESENSE_API_KEY },
      params: { q: searchString, preset: "keepa-search", per_page: 50 },
    });

    if (status !== 200) {
      throw new Error(`Typesense search failed with status ${status}`);
    }

    return {
      responseHeader: {
        status: 0,
        QTime: data.search_time_ms,
        params: data.request_params,
      },
      response: {
        type: "keepa",
        numFound: data.found,
        start: data.page,
        maxScore: 1,
        docs: data.hits,
      } as IKeepaSearchResult,
      spellcheck: {
        suggestions: [],
        correctlySpelled: true,
        collations: [],
      },
    };
  };
}
